import CarouselV2 from '../../elements/CarouselV2/CarouselV2'
import cx from 'classnames'
import styles from './TestimonialCarousel.module.scss'
import { Card } from '~elements'
import { AssetType, RichTextType } from '~types'
import { Settings } from 'react-slick'

export interface TestimonialCardProps {
  hasQuoteSymbol?: boolean
  description?: RichTextType
  logo?: AssetType
  attributionImage?: AssetType
  attributionTitle?: string
  attributionDescription?: string
  theme: 'primary' | 'accent' | 'grey'
}

export interface TestimonialCarouselProps {
  slides: TestimonialCardProps[]
  headline?: string
}

function TestimonialCarousel({ slides, headline }: TestimonialCarouselProps) {
  const carouselSettings: Settings = {
    slidesToScroll: 1,
    speed: 500,
    variableWidth: false,
    centerMode: true,
    dots: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 1920,
        settings: {
          variableWidth: true,
          centerMode: false,
          dots: true
        }
      }
    ]
  }

  const THEMEMAP: Record<TestimonialCardProps['theme'], React.CSSProperties> = {
    primary: { background: 'linear-gradient(90deg, #03343B 0%, #011316 100%)' },
    accent: { background: 'linear-gradient(90deg, #585038 0%, #1D180C 100%)' },
    grey: { background: 'linear-gradient(90deg, #434343 0%, #171717 100%)' }
  }
  // Check if there is at least one slide with a quote symbol
  const someQuoteSymbol = slides.some(slide => slide.hasQuoteSymbol)
  return (
    <div className={styles['testimonial-carousel-module']} data-testid='hero-carousel-module'>
      <div className={cx(styles['testimonial-carousel'])}>
        <CarouselV2
          headline={{ level: 2, justify: 'center', title: headline }}
          slides={slides}
          className={styles['carousel']}
          showAllShowsButton={true}
          carouselSettings={carouselSettings}
          showArrowsBreakpointUp={'md'}
          // @TODO: integrate peekNextSlide prop
          fadePeekingSlides={true}
          sliderContainerClass={styles['slider-container']}
          renderSlide={(slide: TestimonialCardProps, index) => {
            return (
              <Card
                key={index}
                description={{ html: slide.description ? String(slide.description) : null }}
                overrideContainerClass={cx(styles['testimonial-card'], !someQuoteSymbol && styles['no-quote'])}
                overrideBackgroundStyle={THEMEMAP[slide.theme] ?? THEMEMAP.primary}
                isTestimonial={true}
                testimonial={{
                  hasQuoteSymbol: slide.hasQuoteSymbol,
                  someQuoteSymbol: someQuoteSymbol,
                  attributionImage: slide.attributionImage,
                  attributionTitle: slide.attributionTitle,
                  attributionDescription: slide.attributionDescription,
                  companyLogo: slide.logo
                }}
              />
            )
          }}
        />
      </div>
    </div>
  )
}

export default TestimonialCarousel
